/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
    constructor() {
        this.container = document.getElementById("Search-Drawer");
        this.form = document.querySelector("form.searchform");
        this.button = document.querySelectorAll(".thb-quick-search");
        this.input = document.querySelector("#side-panel-search-input");

        this.closeButton = document.querySelector(".custom-search-close");

        this.suggestions = document.querySelectorAll(
            ".custom-search-suggestion"
        );

        this.blur = document.querySelector(
            ".thb-full-menu li.menu-item-has-children.menu-item-has-megamenu"
        );
        this.defaultTab = this.container.querySelector(
            ".custom-search-drawer-default"
        );
        this.predictiveSearchResults = this.container.querySelector(
            ".custom-search-results"
        );

        this.input.classList.remove("no-js");

        document.addEventListener(
            "touchmove",
            (e) => {
                let isOpen = document
                    .getElementsByTagName("body")[0]
                    .classList.contains("open-anti-scroll");

                if (!isOpen) return;

                console.log(isOpen);

                // Prevent scrolling unless the target is within the search drawer
                if (isOpen && !this.container.contains(e.target)) {
                    e.preventDefault();
                }
            },
            {
                passive: false,
            }
        );

        this.setupEventListeners();
    }

    setupEventListeners() {
        this.form.addEventListener("submit", this.onFormSubmit.bind(this));

        this.input.addEventListener(
            "input",
            debounce((event) => {
                this.onChange(event);
            }, 300).bind(this)
        );

        this.input.addEventListener("focus", this.open.bind(this));
        this.input.addEventListener("focusout", this.close.bind(this));

        this.closeButton.addEventListener("click", () => {
            document
                .getElementsByTagName("body")[0]
                .classList.remove("open-anti-scroll");
            this.container.classList.remove("active");
            this.blur?.classList.remove("after-visible");
            this.closeButton.classList.remove("close-active");
        });
    }

    getQuery() {
        return this.input.value.trim();
    }

    open() {
        document
            .getElementsByTagName("body")[0]
            .classList.add("open-anti-scroll");
        this.container.classList.add("active");
        this.blur?.classList.add("after-visible");
        this.closeButton.classList.add("close-active");
    }

    onChange() {
        const searchTerm = this.getQuery();

        if (!searchTerm.length) {
            this.predictiveSearchResults.classList.remove("active");
            this.defaultTab.classList.add("active");
            return;
        }
        this.predictiveSearchResults.classList.add("active");
        this.defaultTab.classList.remove("active");
        this.getSearchResults(searchTerm);
    }

    onFormSubmit(event) {
        if (!this.getQuery().length) {
            event.preventDefault();
        }
    }

    onFocus() {
        const searchTerm = this.getQuery();

        if (!searchTerm.length) {
            return;
        }

        this.predictiveSearchResults.classList.add("active");
        this.defaultTab.classList.remove("active");

        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        const queryKey = searchTerm.replace(" ", "-").toLowerCase();

        this.predictiveSearchResults.classList.add("loading");

        fetch(
            `${theme.routes.predictive_search_url}?q=${encodeURIComponent(
                searchTerm
            )}&${encodeURIComponent(
                "resources[type]"
            )}=product,article,query&${encodeURIComponent(
                "resources[limit]"
            )}=10&section_id=predictive-search`
        )
            .then((response) => {
                this.predictiveSearchResults.classList.remove("loading");
                if (!response.ok) {
                    var error = new Error(response.status);
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser()
                    .parseFromString(text, "text/html")
                    .querySelector(
                        "#shopify-section-predictive-search"
                    ).innerHTML;

                this.renderSearchResults(resultsMarkup);
            })
            .catch((error) => {
                throw error;
            });
    }

    renderSearchResults(resultsMarkup) {
        this.predictiveSearchResults.innerHTML = resultsMarkup;

        let _this = this,
            submitButton = this.container.querySelector(
                "#search-results-submit"
            );

        submitButton.addEventListener("click", () => {
            _this.form.submit();
        });
    }

    close(event) {
        let vw = Math.max(
            document.documentElement.clientWidth || 0,
            window.innerWidth || 0
        );

        if (vw < 1068) {
            return;
        }

        if (
            event.relatedTarget &&
            this.container.contains(event.relatedTarget)
        ) {
            this.input.focus();
            return;
        }

        document
            .getElementsByTagName("body")[0]
            .classList.remove("open-anti-scroll");
        this.container.classList.remove("active");
        this.blur?.classList.remove("after-visible");
    }
}
window.addEventListener("load", () => {
    if (typeof PredictiveSearch !== "undefined") {
        new PredictiveSearch();
    }
});
